import {
    StreamRequestInfo,
    WidgetCustomStreamManager,
    WidgetRestByRequestUidConfig,
    WidgetCustomManagedRestOptions,
} from 'widgets/streaming/widgetStreamManager/WidgetCustomStreamManager';
import State from 'store/State';
import { CorporateActionsRequest } from 'widgets/corpActions/api/CorporateActionsRequest';
import { WidgetRequestResponseByUidRestManager } from 'widgets/streaming/widgetStreamManager/RequestResponse/WidgetRequestResponseByUidRestManager';
import { ActionsDispatcher } from 'store/ActionsDispatcher';
import {
    getSymbolEventsStreamRequestInfo,
    getSymbolEventsStreamRequestInfosForSymbols,
} from './SymbolEventsRequestHelpers';
import IndigoServiceClient from 'communication/IndigoServiceClient';
import RequestProgressService from 'requestProgress/RequestProgressService';
import {
    createCorpActionsClearDataAction,
    createCorpActionsHandleResponseAction,
    createHandleCorpActionsErrorAction,
} from 'widgets/corpActions/store/data/actions';
import IndigoApiError from 'communication/IndigoApiError';
import { CorporateActionsWidgetConfigState } from 'widgets/corpActions/widget/store/config/CorporateActionsWidgetConfigState';
import { WidgetId } from 'widgets/WidgetId';
import { SymbolEventsRequest } from 'widgets/corpActions/api/SymbolEventsRequest';
import { symbolEventsSearch } from 'widgets/corpActions/api/SymbolEventsApiProxy';
import { SymbolEventsResponse } from 'widgets/corpActions/api/SymbolEventsResponse';
import { DataServices } from 'store/Services';

export const corporateActionsStreamConfig: WidgetRestByRequestUidConfig<
    SymbolEventsRequest,
    SymbolEventsResponse
> = {
    apiUid: 'corporateActions',
    managerFactory(
        options: WidgetCustomManagedRestOptions
    ): WidgetCustomStreamManager {
        return new WidgetRequestResponseByUidRestManager(options);
    },
    getWidgetStreamRequestInfo(
        state: State,
        services: DataServices,
        id: WidgetId
    ): Promise<StreamRequestInfo<CorporateActionsRequest> | undefined> {
        return getSymbolEventsStreamRequestInfo(state, services, id);
    },
    getStreamRequestInfosForSymbols(
        state: State,
        services: DataServices,

        symbols: string[],
        config: unknown
    ): Promise<StreamRequestInfo<CorporateActionsRequest>[]> {
        return getSymbolEventsStreamRequestInfosForSymbols(
            state,
            services,
            symbols,
            config as CorporateActionsWidgetConfigState
        );
    },
    callApi(
        _dispatcher: ActionsDispatcher,
        requestProgressService: RequestProgressService,
        indigoServiceClient: IndigoServiceClient,
        _ds: DataServices,
        payload: CorporateActionsRequest
    ): Promise<SymbolEventsResponse> {
        return requestProgressService.invokeAndMonitorRequest(
            'symbolEventsSearch',
            (options) =>
                symbolEventsSearch(indigoServiceClient, payload, options)
        );
    },
    clearRequestData(dispatcher: ActionsDispatcher, key: string): void {
        dispatcher.dispatch(createCorpActionsClearDataAction(key));
    },
    handleMessage(
        dispatcher: ActionsDispatcher,
        key: string,
        _request,
        response: SymbolEventsResponse
    ): void {
        dispatcher.dispatch(
            createCorpActionsHandleResponseAction(key, response)
        );
    },
    handleError(
        dispatcher: ActionsDispatcher,
        key: string,
        _request,
        error: IndigoApiError
    ): void {
        dispatcher.dispatch(createHandleCorpActionsErrorAction(key, error));
    },
    removeRequestData(dispatcher: ActionsDispatcher, key: string): void {
        dispatcher.dispatch(createCorpActionsClearDataAction(key));
    },
};
